import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { adapter } from '../providers/adapter';

export function useForgotPassword() {
  const { t } = useTranslation('auth');
  const [isPending, setIsPending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const sendResetEmail = async (email: string): Promise<void> => {
    setIsPending(true);
    setError(null);
    try {
      await adapter.resetPasswordForEmail(email);
      setIsSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(t('errors.generic')));
    }
    setIsPending(false);
  };

  return { sendResetEmail, isPending, isSuccess, error };
}
